import axios from 'axios'
import keycloak from './keycloak'

// Se importa una sola vez en src/index.js, antes del render. Como todos los
// archivos del proyecto hacen `import axios from 'axios'` (el mismo objeto
// compartido, no una instancia nueva por archivo), este interceptor alcanza
// para inyectar el Bearer token en TODAS las llamadas del front sin tocar
// ninguno de esos archivos uno por uno.
axios.interceptors.request.use((config) => {
  if (keycloak.token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${keycloak.token}`
  }
  return config
})

// Una sola renovación en vuelo aunque varias peticiones reciban 401 a la vez.
let renovacionEnCurso = null
const renovarToken = () => {
  if (!renovacionEnCurso) {
    // -1: fuerza la renovación aunque el token local aún parezca vigente.
    renovacionEnCurso = keycloak.updateToken(-1).finally(() => {
      renovacionEnCurso = null
    })
  }
  return renovacionEnCurso
}

// Un 401 casi siempre es un access token vencido (equipo suspendido o pestaña
// en segundo plano, donde el temporizador de keycloak-js no corre a tiempo).
// Antes de mandar al usuario al login -- y que pierda lo que estaba escribiendo --
// se intenta renovar con el refresh token y se reintenta la petición una vez.
// Solo si la renovación falla (la sesión de Keycloak ya no existe) se redirige.
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config
    if (error?.response?.status !== 401) return Promise.reject(error)

    if (original && !original.reintentadoTrasRenovar) {
      original.reintentadoTrasRenovar = true
      try {
        await renovarToken()
        return axios(original)
      } catch (e) {
        // sin sesión renovable: cae al login de abajo
      }
    }

    keycloak.login()
    return Promise.reject(error)
  }
)

// Al volver a la pestaña (o despertar el equipo) se renueva el token de forma
// preventiva, antes de que la primera petición se encuentre con un 401.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && keycloak.authenticated) {
    keycloak.updateToken(60).catch(() => {
      // si falla, el interceptor de respuesta lo maneja en la siguiente petición
    })
  }
})
